import { api } from './client';

/**
 * Facebook Page sync control panel (administrator only).
 * Endpoints: GET /facebook/status, POST /facebook/sync, GET /facebook/posts,
 * POST /facebook/posts/{id}/retry. Toggles are ordinary settings rows in the
 * `facebook` group, saved through PUT /settings.
 */
export const facebookApi = {
  async status() {
    const res = await api.get('/facebook/status');
    return res?.data?.data ?? {};
  },
  async sync() {
    const res = await api.post('/facebook/sync');
    return res?.data?.data ?? {};
  },
  async posts(params = {}) {
    const res = await api.get('/facebook/posts', { params });
    const body = res?.data;
    return { items: body?.data ?? [], meta: body?.meta ?? null };
  },
  async retry(id) {
    const res = await api.post(`/facebook/posts/${id}/retry`);
    return res?.data?.data ?? null;
  },
  /** values: { auto_publish?: bool, auto_import?: bool, import_since?: string|null } */
  async saveSettings(values) {
    const settings = Object.entries(values).map(([key, value]) => ({
      key: `facebook.${key}`,
      value,
      group: 'facebook',
      type: typeof value === 'boolean' ? 'boolean' : 'string',
    }));
    const res = await api.put('/settings', { settings });
    return res?.data?.data ?? {};
  },
};
